import { createSlice } from '@reduxjs/toolkit';
import emailApi from './emailApi';

const dataSlice = createSlice({
    name: 'email',
    initialState: {
        items: [],
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(emailApi.endpoints.emailList.matchPending, (state) => {
                state.error = null;
            })
            .addMatcher(
                emailApi.endpoints.emailList.matchFulfilled,
                (state, action) => {
                    state.items = action.payload; // Save the new data to the state
                }
            )
            .addMatcher(
                emailApi.endpoints.emailList.matchRejected,
                (state, action) => {
                    state.error = action.error.message;
                }
            );
    },
});

export default dataSlice.reducer;
